// var hostname = 'http://192.168.1.6:8018';
// var hostname = 'https://customer-api.rupbee.in';
var hostname = 'https://customer-api.deltanidhi.com';
var header = {
              'Authorization': 'Bearer ' +localStorage.getItem('token'),
              'Content-Type': 'application/json',
              'rb-session-key': localStorage.getItem('rb_session_key')
            };

var time_zone = "Asia/Kolkata";

var global_usage = {
    
    rtl : false,
    
    app_name : 'Delta Nidhi Limited',
    
    app_version : 2.1,
    
    company_name : 'Cybooz IT Solutions Pvt Ltd',
    
    company_website : 'www.cybooz.com',
                     
    client_secret : 'rno9lv5sJYHVCGAiNMIbYRebN6VBIEdupbiOZueu',
    
    sub_domain_suffix : '@archlytics.com',
    
    links : {

        login                     : hostname+'/oauth/token',
        
        logout                     : hostname+'/logout',
        
        check_valid_token         : hostname+'users/validate/access-token',
        
        my_profile                : hostname+'/profile',
        
        profile_photo             : hostname+'/profile/photo/:id',
        
        change_password           :  hostname+'/change-password',
        
        profile_change_password   :  hostname+'/profile/change-password',
        
        forgot_password           :  hostname+'/forgot-password',
        
        forgot_password_update    :  hostname+'/forgot-password/update',
        
        dashboard                 :  hostname+'/dashboard',
        
        deposit_list              : hostname+'/deposits/list',
         
        deposit_balance           : hostname+'/deposits/:id/balance',
        
        loan_balance              : hostname+'/loans/:id/balance',
        
        loan_list                 : hostname+'/loans/list',
        
        fixed_deposit             : hostname+'/deposits/fixed/:id',
        
        fixed_deposit_ledger      : hostname+'/deposits/fixed/:id/ledger',
        
        savings_deposit           : hostname+'/deposits/savings/:id',
        
        savings_deposit_ledger    : hostname+'/deposits/savings/:id/ledger',
        
        cumulative_deposit        : hostname+'/deposits/cumulative/:id',
        
        cumulative_deposit_ledger : hostname+'/deposits/cumulative/:id/ledger',
        
        recurring_deposit         : hostname+'/deposits/recurring/:id',
        
        recurring_deposit_ledger  : hostname+'/deposits/recurring/:id/ledger',
        
        recurring_deposit_installment_schedule   : hostname+'/deposits/recurring/:id/installment-schedule',
       
        gold_loan                 : hostname+'/loans/gold/:id',
        
        gold_loan_ledger          : hostname+'/loans/gold/:id/ledger',
        
        business_loan             : hostname+'/loans/business/:id',
        
        business_loan_ledger      : hostname+'/loans/business/:id/ledger',
        
        business_loan_emi         : hostname+'/loans/business/:id/emi-chart',
        
        business_loan_emi_pdf     : hostname+'/loans/business/:id/emi-chart/download/pdf',
        
        property_loan             : hostname+'/loans/property/:id',
        
        property_loan_ledger      : hostname+'/loans/property/:id/ledger',
        
        property_loan_emi         : hostname+'/loans/property/:id/emi-chart',
        
        property_loan_emi_pdf     : hostname+'/loans/property/:id/emi-chart/download/pdf',
        
        gold_emi_loan             : hostname+'/loans/gold-emi/:id',
        
        gold_emi_loan_ledger      : hostname+'/loans/gold-emi/:id/ledger',
        
        gold_emi_loan_emi         : hostname+'/loans/gold-emi/:id/emi-chart',
        
        gold_emi_loan_emi_pdf     : hostname+'/loans/gold-emi/:id/emi-chart/download/pdf',
        
        fd_loan                   : hostname+'/loans/fd/:id',
        
        fd_loan_ledger            : hostname+'/loans/fd/:id/ledger',
        
        cd_loan                   : hostname+'/loans/cd/:id',
        
        cd_loan_ledger            : hostname+'/loans/cd/:id/ledger',
        
        project_show              : hostname+'projects/:id',
        
        project_edit              : hostname+'projects/:id/edit',
        
        project_list              : hostname+'projects/list',
        
        project_phase_create      : hostname+'projects/:id/phase/create',
        
        project_phase_edit        : hostname+'projects/:id/phase/:phase_id/edit',
        
        project_phase_delete      : hostname+'projects/:id/phase/:phase_id/delete',
        
        
        role_create               : hostname+'roles/create',
        
        role_show                 : hostname+'roles/:id',
        
        role_list                 : hostname+'roles/list',
        
        role_edit                 : hostname+'roles/:id/edit',
        
        role_delete               : hostname+'roles/:id/delete',
        
        
        sa_role_create            : hostname+'superadmin/roles/create',
        
        sa_role_show              : hostname+'superadmin/roles/:id',
        
        sa_role_list              : hostname+'superadmin/roles/list',
        
        sa_role_edit              : hostname+'superadmin/roles/:id/edit',
        
        sa_role_delete            : hostname+'superadmin/roles/:id/delete',
        
        
        material_create           : hostname+'materials/create',
        
        material_show             : hostname+'materials/:id',
        
        material_list             : hostname+'materials/list',
        
        material_edit             : hostname+'materials/:id/edit',
        
        material_delete           : hostname+'materials/:id/delete',
        
        
        tenant_register           : hostname+'tenant/register',
        
        tenant_list               : hostname+'superadmin/tenants/list',
        
        tenant_show               : hostname+'superadmin/tenants/:id',
         
        tenant_edit               : hostname+'superadmin/tenants/:id/edit',
        
        tenant_show_general_info  : hostname+'superadmin/tenants/:id/general-info',
        
        tenant_show_users         : hostname+'superadmin/tenants/:id/users',
        
        tenant_show_subscription_plan_history: hostname+'superadmin/tenants/:id/subscription-plan-history',
         
        tenant_show_address       : hostname+'superadmin/tenants/:id/address',
        
        verify_otp                : hostname+'verify/otp',
        
        select_language           : hostname+'add/language',
        
        check_sub_domain          : hostname+'tenant/check-subdomain',
        
        generate_otp              : hostname+'generate/otp',
        
        
        
        subscription_plan_list    : hostname+'subscriptionplan/list',
        
        subscription_plan_show    : hostname+'subscriptionplan/:id',
        
        subscription_plan_general_info            : hostname+'subscriptionplan/:id/general-info',
        
        subscription_plan_modules_and_permissions : hostname+'subscriptionplan/:id/modules-and-permissions',
        
        subscription_plan_users   : hostname+'subscriptionplan/:id/users',
        
        
        
        get_countries             : hostname+'countries',
        
        get_states                : hostname+'states/:id',
         
        get_districts             : hostname+'districts/:id',
        
    },
    
    header : header,
    
   

}

export default(global_usage)
